"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var LoadingPillbox_1 = __importDefault(require("Common/AtomicUI/LoadingPillbox/LoadingPillbox"));
var Upload_1 = require("Common/Upload");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importDefault(require("react"));
var RainbowLoadingBar_1 = __importDefault(require("Common/AtomicUI/RainbowLoadingBar/RainbowLoadingBar"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var BASE_CLASS_NAME = "loading-image-card";
var LoadingImageCard = function (_a) {
    var uploadProgress = _a.uploadProgress, onRetry = _a.onRetry;
    var dataUrl = uploadProgress.dataUrl, state = uploadProgress.state, percent = uploadProgress.percent, id = uploadProgress.id;
    if (state === Upload_1.UploadState.Pending) {
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME), draggable: "false" },
            react_1.default.createElement(RainbowLoadingBar_1.default, { percent: percent }),
            react_1.default.createElement("img", { src: dataUrl }),
            react_1.default.createElement(LoadingPillbox_1.default, { percent: percent })));
    }
    else if (state === Upload_1.UploadState.Error) {
        return (react_1.default.createElement("div", { draggable: "false", className: "".concat(BASE_CLASS_NAME, " ").concat(tokens_1.darkTheme) },
            react_1.default.createElement("img", { src: dataUrl }),
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "-retry") },
                react_1.default.createElement(kaleidoscope_1.IconButton, { "aria-label": "Retry image upload", onClick: function () { return onRetry(id); }, icon: react_1.default.createElement(icons_1.Retry, null) }),
                react_1.default.createElement("div", { className: "pillbox-label pillbox-label--red loading-pillbox" }, "Upload failed"))));
    }
};
exports.default = LoadingImageCard;
